import type { ProgramNewsReview } from "@/services/adminProgramNews";

export const CRITIQUE_MAX = 2000;

export function isMine(review: ProgramNewsReview, myEmail: string | null | undefined): boolean {
  if (review.mine === true) return true;
  return !!myEmail && review.reviewerEmail?.toLowerCase() === myEmail.toLowerCase();
}

export function splitReviews(
  reviews: ProgramNewsReview[],
  myEmail: string | null | undefined
): { mine: ProgramNewsReview | null; others: ProgramNewsReview[] } {
  const mine = reviews.find(review => isMine(review, myEmail)) ?? null;
  return { mine, others: reviews.filter(review => review !== mine) };
}
